module.exports = __webpack_public_path__ + "img/33_65.969c6e28.png";